import { useMemo } from 'react';
import { useNavigationAutoObuPairs } from 'entities/navigation';
import { useUserCards } from 'store/features/user/selectors/useUserCards';
import { buildCardNavigateOption, buildObuNavigateOption } from '../utils';

export const useNavigationPairList = () => {
  const navigationAutoObuPairs = useNavigationAutoObuPairs();
  const userCardsAutoNumberPairs = useUserCards();

  const navigationAutoObuPairList = useMemo(
    () =>
      [...(navigationAutoObuPairs ?? []), ...(userCardsAutoNumberPairs ?? [])].map((item) =>
        'obuNumber' in item ? buildObuNavigateOption(item) : buildCardNavigateOption(item)
      ),
    [navigationAutoObuPairs, userCardsAutoNumberPairs]
  );

  return navigationAutoObuPairList;
};
